import Section from "./Section";

const Categorization = ({ language }) => {
  const categories = [
    {
      title: {
        en: "Category A",
        hi: "श्रेणी A",
      },
      items: [
        {
          en: "Base Grant: ₹33 lakh (up to ₹1 crore)",
          hi: "न्यूनतम अनुदान : ₹33 लाख (₹1 करोड़ तक)",
        },
        {
          en: "On Additional Investment (above ₹1 crore): 15% additional subsidy",
          hi: "अतिरिक्त निवेश पर (01 करोड़ से अधिक) :  15% अतिरिक्त अनुदान",
        },
        {
          en: "Maximum Grant Limit: ₹80 lakh",
          hi: "अधिकतम अनुदान सीमा : ₹80 लाख",
        },
      ],
    },
    {
      title: {
        en: "Category B",
        hi: "श्रेणी B",
      },
      items: [
        {
          en: "Base Grant: ₹33 lakh (up to ₹1 crore)",
          hi: " न्यूनतम अनुदान : ₹33 लाख (₹1 करोड़ तक)",
        },
        {
          en: "On Additional Investment (above ₹1 crore): 25% additional subsidy",
          hi: "अतिरिक्त निवेश पर (01 करोड़ से अधिक) : 25% अतिरिक्त अनुदान",
        },
        {
          en: "Maximum Grant Limit: ₹1.20 crore",
          hi: "अधिकतम अनुदान सीमा : ₹1.20 करोड़",
        },
      ],
    },
    {
      title: {
        en: "Category C",
        hi: "श्रेणी C",
      },
      items: [
        {
          en: "Base Grant: ₹33 lakh (up to ₹1 crore)",
          hi: "न्यूनतम अनुदान : ₹33 लाख (₹1 करोड़ तक)",
        },
        {
          en: "On Additional Investment (above ₹1 crore): 30% additional subsidy",
          hi: "अतिरिक्त निवेश पर (01 करोड़ से अधिक) : 30% अतिरिक्त अनुदान",
        },
        {
          en: "Maximum Grant Limit: ₹1.50 crore",
          hi: "अधिकतम अनुदान सीमा : ₹1.50 करोड़",
        },
      ],
    },
  ];

  return (
    <Section
      id="categorization"
      title="Regional Classification / Categorization"
      spaceY4Needed={false}
    >
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat, i) => (
          <div
            key={i}
            className="bg-white border-t-2 border-[#018f9b] shadow-md p-8 rounded-lg min-h-[300px]"
          >
            <h3 className="text-xl font-semibold text-[#018f9b] mb-4">
              {language ? cat.title.hi : cat.title.en}
            </h3>
            <div className="space-y-3 text-sm leading-relaxed">
              {cat.items.map((item, j) => (
                <div key={j} className="flex items-start gap-2">
                  <span className="text-green-600 pt-1">✔</span>
                  <p>{language ? item.hi : item.en}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Categorization;
